import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div`
  border-radius: 12px 12px 0px 0px;
  background-color: ${(props) => (!props.state ? colors.titleStrongWhite : colors.primary)};
`

export const Row = styled.div`
  display: flex;
  width: 100%;
  height: 72px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const SearchContainer = styled.div`
  display: flex;
  flex: 1;
  margin: 0px 30px;
  align-items: center;
  justify-content: center;
`

export const FeatureContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 30px;
`
export const CheckBoxContainer = styled.div`
  display: flex;
  font-family: Circular-Std;
  margin: 0 0 0 12px;
  gap: 22px;
  font-size: 16px;
  color: ${(props) => (!props.state ? colors.strongGray : colors.titleStrongWhite)};
`

export const SearchIcon = styled.div`
  cursor: pointer;
  color: ${(props) => (props.state ? colors.titleStrongWhite : colors.strongGray)};
  margin-left: 16px;
`

export const FileDownloadOutlinedIcon = styled.div`
  cursor: pointer;
  color: ${(props) => (!props.state ? colors.strongGray : colors.titleStrongWhite)};
  margin-left: 12px;
`

export const ForwardToInboxIcon = styled.div`
  cursor: pointer;
  color: ${(props) => (!props.state ? colors.strongGray : colors.titleStrongWhite)};
  margin-left: 12px;
`

export const TuneIcon = styled.div`
  cursor: pointer;
  color: ${(props) => (!props.state ? colors.strongGray : colors.titleStrongWhite)};
  margin-top: 5px;
`

export const Button = styled.div`
  background: transparent;
`

export const Input = styled.input`
  width: 100%;
  min-height: 48px;
  border-radius: 12px;
  border: 1px solid ${colors.softGray};
  &:focus {
    border-color: ${colors.primary};
    outline: none;
  }
  ::placeholder {
    color: ${colors.strongGray};
  }
  font-family: inherit;
  color: ${colors.titleStrongBlack};
  font-size: 16px;
  box-sizing: border-box;
  padding-left: 16px;
  vertical-align: baseline;
  max-width: 393px;
`
